interface StationGlowAnimationProps {
  isVisible: boolean;
}

export const StationGlowAnimation = ({ isVisible }: StationGlowAnimationProps) => {
  if (!isVisible) return null;

  return (
    <svg
      className="absolute inset-0 pointer-events-none -z-10"
      width="100%"
      height="100%"
      style={{
        animation: 'borderGlow 2.4s ease-in-out infinite',
      }}>
      <defs>
        <linearGradient id="glowGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#000000" />
          <stop offset="10%" stopColor="#000000" />
          <stop offset="15%" stopColor="rgba(113, 54, 190, 0.9)" />
          <stop offset="20%" stopColor="rgba(255, 0, 150, 1)" />
          <stop offset="25%" stopColor="rgba(255, 100, 0, 1)" />
          <stop offset="40%" stopColor="rgba(255, 255, 0, 1)" />
          <stop offset="55%" stopColor="rgba(0, 255, 150, 1)" />
          <stop offset="70%" stopColor="rgba(0, 150, 255, 1)" />
          <stop offset="75%" stopColor="rgba(150, 0, 255, 1)" />
          <stop offset="80%" stopColor="rgba(255, 0, 150, 1)" />
          <stop offset="90%" stopColor="rgba(25, 54, 104, 0.9)" />
          <stop offset="100%" stopColor="#000000" />
        </linearGradient>
        <linearGradient id="maskLeft" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="white" stopOpacity="1" />
          <stop offset="5%" stopColor="white" stopOpacity="0.9" />
          <stop offset="12%" stopColor="white" stopOpacity="0.6" />
          <stop offset="20%" stopColor="white" stopOpacity="0.3" />
          <stop offset="30%" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="maskRight" x1="100%" y1="0%" x2="0%" y2="0%">
          <stop offset="0%" stopColor="white" stopOpacity="1" />
          <stop offset="5%" stopColor="white" stopOpacity="0.9" />
          <stop offset="12%" stopColor="white" stopOpacity="0.6" />
          <stop offset="20%" stopColor="white" stopOpacity="0.3" />
          <stop offset="30%" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="maskTop" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="white" stopOpacity="1" />
          <stop offset="5%" stopColor="white" stopOpacity="0.9" />
          <stop offset="12%" stopColor="white" stopOpacity="0.6" />
          <stop offset="20%" stopColor="white" stopOpacity="0.3" />
          <stop offset="30%" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="maskBottom" x1="0%" y1="100%" x2="0%" y2="0%">
          <stop offset="0%" stopColor="white" stopOpacity="1" />
          <stop offset="5%" stopColor="white" stopOpacity="0.9" />
          <stop offset="12%" stopColor="white" stopOpacity="0.6" />
          <stop offset="20%" stopColor="white" stopOpacity="0.3" />
          <stop offset="30%" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <mask id="glowMask">
          <rect width="100%" height="100%" fill="black" />
          <rect width="20%" height="100%" fill="url(#maskLeft)" />
          <rect x="80%" width="20%" height="100%" fill="url(#maskRight)" />
          <rect width="100%" height="30%" fill="url(#maskTop)" />
          <rect y="70%" width="100%" height="30%" fill="url(#maskBottom)" />
        </mask>
      </defs>
      <rect
        width="100%"
        height="100%"
        fill="url(#glowGradient)"
        mask="url(#glowMask)"
        style={{
          filter: 'blur(50px)',
        }}
      />
    </svg>
  );
};
